export const DRAWER_WIDTH = 260 // px
export const MINI_DRAWER_WIDTH = 90 // px

// payment speeds
export const ACH_STANDARD = 'ACH_STANDARD'
export const ACH_EXPEDITED = 'ACH_EXPEDITED'
export const ACH_NEXT_DAY = 'ACH_NEXT_DAY'
export const ACH_SAME_DAY = 'ACH_SAME_DAY'
export const DEFAULT = 'DEFAULT'

export const PAYMENT_OPTION_LABELS: Record<string, string> = {
  [DEFAULT]: 'Same speed as before',
  [ACH_STANDARD]: 'ACH: 4-5 business days',
  [ACH_EXPEDITED]: 'ACH: 2-3 business days',
  [ACH_NEXT_DAY]: 'ACH: 1 business day',
  [ACH_SAME_DAY]: 'ACH: Same business day',
}
